import axios from 'axios'

const MIN_SEARCH_LENGTH = 2

let activeCancel = null

export function abortMemberShortSearch() {
  if (activeCancel) {
    activeCancel.cancel()
    activeCancel = null
  }
}

export function createMemberShortSearchCancelToken() {
  abortMemberShortSearch()
  activeCancel = axios.CancelToken.source()
  return activeCancel.token
}

export function isMemberSearchCancelled(error) {
  return axios.isCancel(error)
}

export async function runMemberSearchQuery(vm, string, cb, options = {}) {
  const { skipMinLength = false } = options

  if (!string || (!skipMinLength && string.length < MIN_SEARCH_LENGTH)) {
    abortMemberShortSearch()
    cb([])
    return
  }

  const cancelToken = createMemberShortSearchCancelToken()
  const keyword = string

  try {
    const { items } = await vm.$store.dispatch('member/fetchListShort', {
      search: keyword,
      cancelToken,
    })

    if (keyword !== vm.filterData.search) {
      cb([])
      return
    }

    if (items.length > 0) {
      vm.searchNone = false
      cb(
        items.map((item) => ({
          ...item,
          value: item.phoneNumber,
        }))
      )
    } else {
      vm.searchNone = true
      cb([{ value: '查無會員，立刻新增會員' }])
    }
  } catch (error) {
    if (isMemberSearchCancelled(error)) {
      cb([])
      return
    }
    throw error
  }
}

function showAutocompleteSuggestions(vm, suggestions) {
  const autocomplete = vm.$refs.autocomplete
  if (!autocomplete) {
    return
  }

  autocomplete.loading = false
  if (autocomplete.suggestionDisabled) {
    return
  }
  if (Array.isArray(suggestions)) {
    autocomplete.suggestions = suggestions
    autocomplete.highlightedIndex = autocomplete.highlightFirstItem ? 0 : -1
  }
  autocomplete.activated = true
  vm.$nextTick(() => {
    const input = autocomplete.getInput()
    if (input) {
      autocomplete.broadcast('ElAutocompleteSuggestions', 'visible', [
        autocomplete.suggestionVisible,
        input.offsetWidth,
      ])
    }
  })
}

export function triggerMemberSearchByBtn(vm) {
  const keyword = vm.filterData.search
  if (!keyword) {
    return
  }

  const autocomplete = vm.$refs.autocomplete
  if (!autocomplete) {
    return
  }

  autocomplete.activated = true
  autocomplete.loading = true

  runMemberSearchQuery(
    vm,
    keyword,
    (suggestions) => {
      showAutocompleteSuggestions(vm, suggestions)
    },
    { skipMinLength: true }
  ).catch(() => {
    autocomplete.loading = false
  })
}
